import React from "react";

import useTranslations from "../../../hooks/useTranslations";
import { FormStepProps } from "../../../screens/ReviewFormScreen";

import { Container, H3 } from "../../wombat-ui";

import ReviewSupervisorsForm from "./ReviewSupervisorsForm";
import ReviewSchedulingForm from "./ReviewSchedulingForm";
import ReviewInformationForm from "./ReviewInformationForm";
import ReviewSettingsForm from "./ReviewSettingsForm";
import useViewer from "../../../hooks/useViewer";
import ReviewReminderForm from "./ReviewReminderForm";
import { ReviewFullFragment } from '../../../graphql/generated/definitions';
import ReviewReferentsForm from "./ReviewReferentsForm";

const ReviewConfigurationForm: React.FC<
  Omit<FormStepProps, "onNext"> & { defaultValues?: ReviewFullFragment }
> = (props) => {
  const t = useTranslations();
  const viewer = useViewer();

  return (
    <Container className="flex flex-col flex-grow w-full space-y-6 text-primary-900">
      <H3>{t("reviews.chooseReferents")}</H3>
      <ReviewReferentsForm control={props.control} defaultValues={props.defaultValues}/>

      <H3>{t("reviews.supervisionConfiguration")}</H3>
      <ReviewSupervisorsForm {...props} name="reviewSupervisorsAttributes" />

      {
        viewer.company.inlineTemplateUpdateEnabled && (
          <>
            <H3>{t("reviews.settings")}</H3>
            <ReviewSettingsForm {...props} />    
          </>
        )
      }

      <H3>{t("reviews.reportsFrequencyTitle")}</H3>
      <ReviewSchedulingForm {...props} />

      <H3>{t("reviews.reportsReminderTitle")}</H3>
      <ReviewReminderForm {...props} />

      <H3>{t("reviews.reviewTitleSet")}</H3>
      <ReviewInformationForm {...props} />
    </Container>
  );
};

export default React.memo(ReviewConfigurationForm);
